import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  connectModal,
  FileUpload,
  Spinner,
  Alert,
} from '@gsa/afp-component-library';
import { useUploadVehicles } from '../../../../requests/vehicle-referral';

export const ACCEPT_FILE_TYPES = ['text/csv'];

export const ACCEPT_FILE_LABELS = 'Accepts .csv files';
const UploadVehicleModal = ({ handleCancel }) => {
  const [vins, setVins] = useState(null);
  const [error, setError] = useState(null);
  const [uploadVehicles, { loading: uploadVehiclesLoading }] =
    useUploadVehicles();

  // Track when vins state updates
  useEffect(() => {
    if (vins) {
      console.log('Vin list procured', vins.length);
    }
  }, [vins]);

  const handleSubmit = () => {
    if (!vins || vins.length === 0) {
      console.log('No VINs to submit');
      return;
    }

    uploadVehicles({ variables: { vins } });
    handleCancel();
  };

  const handleCsvFileUpload = (file) => {
    const reader = new FileReader();
    let result = '';
    reader.onload = (e) => {
      const text = e.target.result;
      result = text;
    };
    reader.onloadend = () => {
      // Handle both Windows (\r\n) and Unix (\n) line endings
      const lines = result.split(/\r?\n/).filter((line) => line.trim() !== '');
      const headers = lines[0].split(',');

      // Clean the header - remove quotes and whitespace
      const cleanHeader = headers[0].replace(/['"]/g, '').trim();

      if (cleanHeader !== 'VIN') {
        setError('First column must be named VIN');
        return;
      }

      const data = lines
        .slice(1)
        .map((line) => {
          const values = line.split(',');
          // Remove quotes, whitespace, and any carriage returns
          const vin = values[0].replace(/['"]/g, '').replace(/\r/g, '').trim();
          return vin;
        })
        .filter((vin) => vin.length > 0); // Filter out empty VINs

      setVins(data);
      setError(null); // Clear any previous errors

      return data;
    };
    reader.readAsText(file);
  };

  return (
    <>
      <Modal
        onClose={handleCancel}
        actions={
          <>
            <Button
              type="button"
              variant="unstyled"
              onClick={handleCancel}
              label="Cancel"
              className="padding-right-2"
            />
            <Button
              type="submit"
              variant="primary"
              onClick={handleSubmit}
              leftIcon={uploadVehiclesLoading ? <Spinner /> : { name: 'check' }}
              label={uploadVehiclesLoading ? 'Uploading...' : 'Confirm'}
              disabled={
                !vins || vins.length === 0 || uploadVehiclesLoading || error
              }
            />
          </>
        }
      >
        <div>
          <p>
            Upload a CSV file with the VINs of the vehicles you want to add to
            the referral request.
          </p>
        </div>

        <div className="margin-top-2 padding-2 bg-primary-lightest padding">
          <FileUpload
            acceptableFiles={ACCEPT_FILE_TYPES}
            data-testid="referral-request-upload-file"
            acceptableFilesLabel={ACCEPT_FILE_LABELS}
            onChange={handleCsvFileUpload}
            label="Refer vehicles"
          />
        </div>
        {error && <Alert type="error">{error}</Alert>}
      </Modal>
      {uploadVehiclesLoading && <Spinner />}
    </>
  );
};

export default connectModal(UploadVehicleModal);
